/**
 * Small inline license status ("License expires on …"). Renders nothing on
 * unlicensed builds, so it is safe to drop anywhere. Reads the cached result
 * from the boot-time validation done by LicenseGate.
 */
import React from 'react';
import { licenseStatusLabel, getLicenseInfo } from './license';

export const LicenseInfo: React.FC<{ className?: string }> = ({ className }) => {
    const label = licenseStatusLabel();
    if (!label) {
        return null;
    }
    const info = getLicenseInfo();
    const invalid = info && info.valid === false;
    return (
        <span
            className={className}
            title={info?.client ? `Licensed to ${info.client}` : undefined}
            style={invalid ? { color: '#f87171' } : undefined}
        >
            {label}
        </span>
    );
};
